import React, { useEffect, useState } from "react";
import "./style.css";
import ActiveSubscription from "./child/active/ActiveSubscription";
import Layout from "../components/resusable/layout/layout";
import UserManagement from "./child/user-mangement/UserManagement";
import Payments from "./child/payments/Payments";
import InActiveSubscription from "./child/in-active/InActiveSubscription";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getBellingSession,
  getMyOrganization,
} from "../components/https/planSubscriptions";
import { LoadingOutlined } from "@ant-design/icons";

import { _setMyOrganizationData } from "../redux/actions/generalAction";
import CustomSpinner from "../dentail-indetifcation/components/d-reusable/CustomSpiner";
import { errorRequestHandel, isAdminLogin } from "../helper";
import useAdminGuard from "../hooks/useAdminGuard";
import useIsAdmin from "../hooks/useIsAdmin";
import CustomModal from "../age-assessment/components/modals/CustomModal";
import ConfirmationModal from "./ConfirmationModal";
import { Spin } from "antd";

const Subscriptions = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isloading, setisLoading] = useState(false);
  const privileges = useSelector((state) => state.auth?.privileges);
  const [refetch, setRefetch] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const myOrganization = useSelector((state) => state.general?.myOrganization);

  const isUserAlreadyOnStripe = myOrganization?.subscriptions.some(
    (sub) => sub.type === "stripe"
  );

  const isAdmin = useIsAdmin();
  useAdminGuard(isAdmin, privileges?.onPremises);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    getMyOrganizations();
  }, [refetch]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const source = params.get("source");
    const status = params.get("status");

    if (source === "stripe" && status === "completed") {
      setShowConfirmationModal(true);

      // Clear the query string after a short delay (so modal can still show based on query)
      setTimeout(() => {
        navigate(location.pathname, { replace: true });
      }, 500); // delay ensures state update triggers modal first
    }
  }, [location, navigate]);

  const getMyOrganizations = async () => {
    try {
      setLoading(true);
      const resposen = await getMyOrganization();
      if (resposen.status === 200) {
        dispatch(_setMyOrganizationData(resposen.data.data));

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };

  const onUpdateBillingInformation = async () => {
    try {
      setisLoading(true);
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const returnUrl = `${baseUrl}/subscription`;
      const response = await getBellingSession({ returnUrl: returnUrl });
      if (response.status === 200) {
        const sessionUrl = response?.data?.url; // or whatever your API returns

        if (sessionUrl) {
          window.open(sessionUrl, "_blank"); // open in new tab
          setisLoading(false);
        }
      }
    } catch (error) {
      setisLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  return (
    <Layout>
      <CustomSpinner loading={loading} />
      <div className="subscriptions_container">
        <div className="subscriptions_body">
          <div className="subscriptions_action">
            <h5>Subscription Plan</h5>
            {isloading ? (
              <Spin
                indicator={<LoadingOutlined spin />}
                size="large"
                style={{ color: "#0A9FD4" }}
              />
            ) : (
              <>
                {isUserAlreadyOnStripe && (
                  <p onClick={onUpdateBillingInformation}>
                    Update Billing Information
                  </p>
                )}
              </>
            )}
          </div>
          {privileges?.hasSubscription ? (
            <ActiveSubscription
              loading={loading}
              onRefetch={() => setRefetch(!refetch)}
            />
          ) : (
            <InActiveSubscription />
          )}

          <UserManagement onRefetch={() => setRefetch(!refetch)} />
          <Payments />
        </div>
      </div>

      <CustomModal
        open={showConfirmationModal}
        width={"50%"}
        onCancel={() => setShowConfirmationModal(false)}
      >
        <ConfirmationModal onCancel={() => setShowConfirmationModal(false)} />
      </CustomModal>
    </Layout>
  );
};

export default Subscriptions;
